import React from 'react';
import styles from './AdminClubList.module.scss';
import { Box } from '@mui/material';
import { formatPhoneNumber } from '../AdminUserList/AdminUserList';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { clubList } from '../../../redux/actions/app/clubList';
const AdminClubList = () => {
  const getClubLoginPhone = (val) => val?.creator?.phone ?? val?.phone;
  const getClubLoginCitizenship = (val) => val?.creator?.citizenship ?? val?.citizenship;

  const columns = [
    {
      label: 'Аватар',
      onTransform: (val) => <Box component={'img'} src={val?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px', margin: '0 auto' }}></Box>,
    },
    {
      label: 'Название',
      onTransform: (val) => val?.name,
    },
    {
      label: 'Телефон',
      onTransform: (val) => {
        const phone = getClubLoginPhone(val);
        const citizenship = getClubLoginCitizenship(val);

        return phone ? formatPhoneNumber(phone, citizenship) : '-';
      },
    },
    {
      label: 'Адрес',
      onTransform: (val) => val?.address ?? '-',
    },

    {
      label: 'Город',
      onTransform: (val) => val?.city?.name ?? '-',
    },

    {
      label: 'Почта',
      onTransform: (val) => val?.email ?? '-',
    },
  ];
  return (
    <div>
      <AdminTableList title={'Клубы'} sliceName={'app'} actionName={'clubList'} fetch={clubList} pathEdit="/admin/club/edit" columns={columns} textEmpty={'Клубов нет'} />
    </div>
  );
};

export default AdminClubList;
